import { Link } from "react-router-dom";

export const FOOTER_PAGES = {
  "centre-aide": "Centre d'aide", "securite-confiance": "Sécurité & confiance", contact: "Contact", "a-propos": "À propos",
  confidentialite: "Confidentialité", cookies: "Cookies et stockage local", "sous-traitants": "Sous-traitants", dpa: "DPA",
  "mentions-legales": "Mentions légales", cgu: "CGU", "conditions-commerciales": "Conditions commerciales",
  "signalement-vulnerabilite": "Signalement de vulnérabilité",
};

const COLUMNS = [
  ["Aide", ["centre-aide", "securite-confiance", "contact", "a-propos"]],
  ["Confidentialité", ["confidentialite", "cookies", "sous-traitants", "dpa"]],
  ["Légal", ["mentions-legales", "cgu", "conditions-commerciales", "signalement-vulnerabilite"]],
];

export const SiteFooter = ({ className = "" }) => (
  <footer data-testid="site-footer" className={`border-t border-border ${className}`}>
    <div className="mx-auto grid max-w-6xl grid-cols-2 gap-8 px-4 py-10 md:grid-cols-4 md:px-8">
      {COLUMNS.map(([title, slugs]) => (
        <div key={title}>
          <p className="mb-3 text-sm font-semibold">{title}</p>
          <ul className="space-y-2">
            {slugs.map((s) => (
              <li key={s}>
                <Link to={`/infos/${s}`} data-testid={`footer-link-${s}`} className="text-sm text-muted-foreground transition-colors hover:text-amber-500">{FOOTER_PAGES[s]}</Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
      <div>
        <p className="mb-3 text-sm font-semibold" data-testid="footer-brand">doli.nc</p>
        <p className="text-xs text-muted-foreground">Nouvelle-Calédonie</p>
      </div>
    </div>
  </footer>
);
